import React from 'react';
import { ArrowRightIcon, QuoteIcon } from 'lucide-react';
import { CUSTOMER_EVIDENCE, PILOT_NOTE, VC_PATH, BRAND } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { CtaButton } from '../ui/CtaButton';
import { LogoStrip } from '../dgpt/LogoStrip';
export function VcProofSection() {
  return <section id="venture-capital" aria-labelledby="vc-proof-heading" className="scroll-mt-20 border-b border-hairline-soft bg-ink" data-id="element-378" data-mp="1az2874fatb7p">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-379" data-mp="i8twnvf9pp23">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-14" data-id="element-380" data-mp="w8betry2642h">
          <div className="flex flex-col items-start" data-id="element-381" data-mp="s6gh0xfc68tg">
            <SectionHeading eyebrow="Our track record" headingId="vc-proof-heading" title="Where we started: venture capital." description="Funds and accelerators use DiligenceGPT™ to screen deal flow, compare diligence and assess applicants. It’s our most mature workflow." data-id="element-382" data-mp="s4wyf067jloi" />
            <p className="mt-4 text-sm font-semibold text-text-primary" data-id="element-383" data-mp="1kguyqp01t4d6">{BRAND.tagline}</p>
            <CtaButton href={VC_PATH} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-384" data-mp="1oj7s0dxlz9t2">
              Explore DiligenceGPT for VC
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-385" data-mp="1tgzuu2zskgc1" />
            </CtaButton>
          </div>

          <ul className="grid gap-3" data-id="element-386" data-mp="wt3aqo55b2w2">
            {CUSTOMER_EVIDENCE.map((item, index) => <Reveal key={item.organization} as="li" delay={index * 0.05} className="flex gap-4 rounded-2xl border border-hairline bg-panel p-5" data-id="element-387" data-mp="10uf331fem27y" data-mpi={index}>
                <QuoteIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-388" data-mp="15qnd60eqv589" />
                <div data-id="element-389" data-mp="1al1e0ic6e4kb">
                  <blockquote className="text-[15px] leading-relaxed text-text-primary" data-id="element-390" data-mp="d42leyucwr46">“{item.quote}”</blockquote>
                  <p className="mt-3 text-xs text-text-tertiary" data-id="element-391" data-mp="i2461o7fkyhr">
                    <span className="font-semibold text-text-secondary" data-id="element-392" data-mp="i0je86ci3tnl">
                      {item.person}, {item.role}
                    </span>{' '}
                    · {item.organization} ({item.relationship.toLowerCase()})
                  </p>
                </div>
              </Reveal>)}
          </ul>
        </div>

        <div className="mt-14 border-t border-hairline-soft pt-10" data-id="element-393" data-mp="1q49v0vllx7wh">
          <LogoStrip data-id="element-394" data-mp="12exiblr2mhpf" />
          <p className="mt-4 text-center text-xs text-text-tertiary" data-id="element-395" data-mp="12e5pgiouyy2u">{PILOT_NOTE}</p>
        </div>
      </div>
    </section>;
}